module.exports = __webpack_public_path__ + "static/media/homeicon.a2b6f4fc.svg";